





















































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {
  CreateSchemeManage,
  GetObsTokenForScheme,
  GetSchemeManageOptions,
  GetSchemeManagePage,
  SchemeManageCreatePayload,
  SchemeManageItem,
  SchemeManageUpdatePayload,
  SchemeOptionItem,
  UpdateSchemeManage,
} from '../api/scheme/index';

type SchemeManagePageResult = {
  records: SchemeManageItem[];
  total: number;
};

function createForm() {
  return {
    sn: '',
    title: '',
    industryCode: '',
    productCategoryCode: '',
    fileName: '',
    fileUrl: '',
    fileType: 'pdf',
    fileSize: 0,
  };
}

@Component
export default class SchemeManage extends Vue {
  acceptFileType = '.pdf,.PDF';

  dialogMode: 'create' | 'edit' = 'create';

  pageLoading = false;
  submitLoading = false;
  uploadLoading = false;
  createDialogVisible = false;

  total = 0;
  schemeList: SchemeManageItem[] = [];
  industryOptions: SchemeOptionItem[] = [];
  productOptions: SchemeOptionItem[] = [];

  uploadServer = '';
  uploadPayload = {};

  query = {
    keyword: '',
    industryCode: '',
    productCategoryCode: '',
    pageNum: 1,
    pageSize: 10,
  };

  form = createForm();

  formRules = {
    industryCode: [{ required: true, message: '请选择行业生态', trigger: 'change' }],
    productCategoryCode: [{ required: true, message: '请选择产品分类', trigger: 'change' }],
    title: [
      {
        validator: (_rule: any, value: string, callback: Function) => this.validateRequiredText(value, '请输入方案名称', callback),
        trigger: 'blur',
      },
    ],
    fileName: [
      {
        validator: (_rule: any, value: string, callback: Function) => this.validateRequiredText(value, '请输入文件名称', callback),
        trigger: 'blur',
      },
    ],
    fileUrl: [{ required: true, message: '请上传 PDF 文件', trigger: 'change' }],
  };

  get dialogTitle() {
    return this.dialogMode === 'edit' ? '编辑方案' : '新增方案';
  }

  get dialogDesc() {
    return this.dialogMode === 'edit' ? '修改方案信息，必要时重新上传 PDF 文件。' : '上传 PDF 文件并绑定行业生态与产品分类。';
  }

  get submitText() {
    return this.dialogMode === 'edit' ? '保存修改' : '保存方案';
  }

  async mounted() {
    await Promise.all([this.fetchOptions(), this.fetchSchemeList()]);
  }

  async fetchOptions() {
    try {
      const res = await GetSchemeManageOptions();
      this.industryOptions = Array.isArray(res && res.industryList) ? res!.industryList : [];
      this.productOptions = Array.isArray(res && res.productList) ? res!.productList : [];
    } catch (error) {
      this.industryOptions = [];
      this.productOptions = [];
    }
  }

  async fetchSchemeList() {
    this.pageLoading = true;
    try {
      const res = (await GetSchemeManagePage({ ...this.query })) as SchemeManagePageResult;
      this.schemeList = Array.isArray(res && res.records) ? res.records : [];
      this.total = Number((res && res.total) || 0);
    } finally {
      this.pageLoading = false;
    }
  }

  handleSearch() {
    this.query.pageNum = 1;
    this.fetchSchemeList();
  }

  handleReset() {
    this.query.keyword = '';
    this.query.industryCode = '';
    this.query.productCategoryCode = '';
    this.query.pageNum = 1;
    this.query.pageSize = 10;
    this.fetchSchemeList();
  }

  handlePageNumChange(pageNum: number) {
    this.query.pageNum = pageNum;
    this.fetchSchemeList();
  }

  handlePageSizeChange(pageSize: number) {
    this.query.pageSize = pageSize;
    this.query.pageNum = 1;
    this.fetchSchemeList();
  }
  openCreateDialog() {
    this.dialogMode = 'create';
    this.createDialogVisible = true;
    this.resetForm();
  }

  openEditDialog(row: SchemeManageItem) {
    if (!row || !row.sn) {
      this.$message.warning('方案数据异常，请刷新后重试');
      return;
    }
    this.dialogMode = 'edit';
    this.form = {
      sn: row.sn,
      title: row.title || '',
      industryCode: row.industryCode || '',
      productCategoryCode: row.productCategoryCode || '',
      fileName: row.fileName || '',
      fileUrl: row.fileUrl || '',
      fileType: row.fileType || 'pdf',
      fileSize: Number(row.fileSize || 0),
    };
    this.uploadServer = '';
    this.uploadPayload = {};
    this.createDialogVisible = true;
    this.$nextTick(() => {
      const formRef = this.$refs.formRef as any;
      formRef && formRef.clearValidate();
    });
  }

  handleCreateDialogClosed() {
    this.resetForm();
  }

  resetForm() {
    this.form = createForm();
    this.uploadServer = '';
    this.uploadPayload = {};
    this.$nextTick(() => {
      const formRef = this.$refs.formRef as any;
      formRef && formRef.clearValidate();
    });
  }

  async handleBeforeUpload(file: any) {
    const fileName = String(file.name || '');
    const lowerName = fileName.toLowerCase();
    if (!lowerName.endsWith('.pdf')) {
      this.$message.error('仅支持上传 PDF 文件');
      return false;
    }
    this.uploadLoading = true;
    try {
      const res = await GetObsTokenForScheme({ suffix: 'pdf', prefix: 'scheme/manage' });
      this.uploadServer = res.host;
      this.uploadPayload = {
        key: res.key,
        policy: res.policy,
        signature: res.signature,
        AccessKeyId: res.accessid,
        success_action_status: '200',
      };
      file.originalUrl = res.cdn + res.key;
      return true;
    } catch (error) {
      this.uploadLoading = false;
      this.$message.error('获取上传凭证失败，请重试');
      return false;
    }
  }

  handleUploadSuccess(res: any, file: any) {
    this.uploadLoading = false;
    const raw = file && file.raw ? file.raw : {};
    const uploadedName = String(raw.name || '');
    this.form.fileUrl = raw.originalUrl || '';
    this.form.fileName = uploadedName;
    this.form.fileType = 'pdf';
    this.form.fileSize = Number(raw.size || 0);
    if (!String(this.form.title || '').trim()) {
      this.form.title = uploadedName.replace(/\.pdf$/i, '');
    }
    this.$nextTick(() => {
      const formRef = this.$refs.formRef as any;
      formRef && formRef.validateField('fileUrl');
      formRef && formRef.validateField('title');
      formRef && formRef.validateField('fileName');
    });
  }

  handleUploadError() {
    this.uploadLoading = false;
    this.$message.error('文件上传失败，请重试');
  }

  buildPayload(): SchemeManageCreatePayload {
    return {
      title: String(this.form.title || ''),
      industryCode: this.form.industryCode,
      productCategoryCode: this.form.productCategoryCode,
      fileName: this.form.fileName,
      fileUrl: this.form.fileUrl,
      fileType: 'pdf',
      fileSize: Number(this.form.fileSize || 0),
    };
  }

  buildUpdatePayload(): SchemeManageUpdatePayload {
    return {
      ...this.buildPayload(),
      sn: this.form.sn,
    };
  }

  handleSubmit() {
    const formRef = this.$refs.formRef as any;
    formRef.validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      this.submitLoading = true;
      try {
        if (this.dialogMode === 'edit') {
          if (!this.form.sn) {
            this.$message.warning('方案数据异常，请刷新后重试');
            return;
          }
          await UpdateSchemeManage(this.buildUpdatePayload());
          this.$message.success('方案修改成功');
        } else {
          await CreateSchemeManage(this.buildPayload());
          this.$message.success('方案新增成功');
          this.query.pageNum = 1;
        }
        this.createDialogVisible = false;
        await this.fetchSchemeList();
      } finally {
        this.submitLoading = false;
      }
    });
  }

  validateRequiredText(value: string, message: string, callback: Function) {
    if (!String(value || '').trim()) {
      callback(new Error(message));
      return;
    }
    callback();
  }

  handlePreview(url: string) {
    if (!url) {
      this.$message.warning('预览地址不存在');
      return;
    }
    window.open(url, '_blank');
  }

  formatDate(value: string) {
    if (!value) {
      return '-';
    }
    return value.replace('T', ' ');
  }

  formatFileSize(value: number | string) {
    const size = Number(value || 0);
    if (!size) {
      return '未知大小';
    }
    if (size < 1024) {
      return size + ' B';
    }
    if (size < 1024 * 1024) {
      return (size / 1024).toFixed(2) + ' KB';
    }
    if (size < 1024 * 1024 * 1024) {
      return (size / (1024 * 1024)).toFixed(2) + ' MB';
    }
    return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
  }
}
